import { render, staticRenderFns } from "./ProductCouponStar.vue?vue&type=template&id=3ec01f1c&scoped=true&"
import script from "./ProductCouponStar.vue?vue&type=script&lang=js&"
export * from "./ProductCouponStar.vue?vue&type=script&lang=js&"
import style0 from "./ProductCouponStar.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ProductCouponStar.vue?vue&type=style&index=1&id=3ec01f1c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec01f1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDivider,VListItem,VListItemContent,VRadio,VRadioGroup,VRow,VTextField})
